import { css } from "styled-components";

export const variables = css`
  :root {
    --element-padding-mobile: 20px;
    --modal-element-padding: 40px;
    --modal-element-padding-mobile: 20px;
    --element-max-width: 1220px;
    --element-max-width-md: 900px;
    --element-max-width-sm: 540px;
    --header-button-hight: 56px;
    --notifications-container-z-index: 20000;
    --nft-card-z-index: 9999;

    /* NEW COLORS */
    --primary: #614fda;
    --primary-light: #2d3271;
    --primary-lighter: #8674ff;
    --secondary: #24e8c5;
    --secondary-light: #74baae;
    --secondary-lighter: #3f5d6a;
    --background: #0e0e18;
    --background-1: #0b0b23;
    --background-2: #151731;
    --background-2-darker: #0c0e25;
    --background-3: #242541;
    --background-4: #3b3e6d;
    --disabled-input: #070a14;
    --markdown-code-backgroud: rgba(110, 118, 129, 0.4);

    --white: #ffffff;
    --error-red: #ff6464;
    --error-red-background: #4f1a1a;
    --warning-yellow: #f2c94c;
    --warning-yellow-background: #746023;
    --success-green: #00ff0a;

    --grey-400: #d0d5dd;
    --grey-500: #667085;
    --grey-600: #424751;
    --grey-700: #343841;
    --grey-800: #282c33;
    --grey-900: #424751;
    /* ----------------------- */

    /* colors */
    --black: #000206;
    --dark-blue: #000723;
    --moderate-blue: #000930;
    --strong-blue: #001571;
    --turquoise: #8afcfd;
    --teal: #00a1a3;
    --blue: #000c3b;
    --blue-2: #101b4e;
    --blue-3: #1c2c74;
    --blue-4: #6472af;
    --field-blue: #0c1436;
    --light-blue: #041558;
    --light-blue-2: #4c80d0;
    --purple-blue: #1f2748;
    --vault-blue: #0524a7;
    --turquoise-1: #58ccb1;
    --turquoise-2: #428a8d;
    --turquoise-3: #24a19b;
    --dark-turquoise: #9bc8ca;
    --dirty-turquoise: #64c1c5;
    --red: #eb889d;
    --red-2: #f24822;
    --strong-red: #e66480;
    --green: green;
    --bright-green: #05ff00;
    --drak-green: #34d058;
    --orange: #d1891d;
    --yellow: #f2c94c;
    --transparent-black: rgba(0, 0, 0, 0.2); // for modal
    --gray: #c6c6c6;
    --gray-2: #8d8d8d;
    --light-gray: #212842;
    --azure: #13a8fd;
    --purple: #4f72eb;
    --strong-purple: #4b239f;
    --strong-purple-2: #5662f6;

    --background-clear-blue-2: #171728;
    --background-clear-blue: #161b2f;
    --background-clearer-blue: #212639;

    /* pie chart colors */
    --token: #14595b;
    --vested-token: #296b6d;
    --committee: #3e7d7f;
    --vested-hats: #548e91;
    --governance: #69a0a3;
    --swap-and-burn: #7eb2b5;

    --severity-audit-request: #d1891d;

    --committee-blue: #c0f2f2;

    --vault-editor-border: #59648f;
    --vault-editor-border-2: #212842;

    /* font sizes */
    --xxxxlarge: 88px;
    --xxxlarge: 72px;
    --xxlarge: 60px;
    --xlarge: 48px;
    --large-2: 42px;
    --large: 36px;
    --medium-2: 32px;
    --medium: 24px;
    --moderate-big: 22px;
    --moderate: 18px;
    --small: 16px;
    --xsmall: 14px;
    --xxsmall: 12px;
    --tiny: 10px;

    /* spacing */
    --spacing-quarter: 2px;
    --spacing-half: 4px;
    --spacing-1: 8px;
    --spacing-2: 16px;
    --spacing-3: 24px;
    --spacing-4: 32px;
    --spacing-5: 40px;
    --spacing-6: 48px;
    --spacing-7: 56px;
    --spacing-8: 64px;
    --spacing-9: 72px;
    --spacing-10: 80px;
    --spacing-11: 88px;
    --spacing-12: 96px;
    --spacing-13: 104px;
    --spacing-14: 112px;
    --spacing-15: 120px;
    --spacing-16: 128px;
    --spacing-18: 144px;
    --spacing-20: 160px;
    --spacing-25: 200px;

    /* others */
    --small-mobile-breakpoint: 600px;
    --mobile-breakpoint: 1100px;
    --small-screen-breakpoint: 1600px;
    --black-shadow: 0 13px 32px rgb(0 0 0 / 30%); // for modal
    --sidebar-shadow: rgba(0, 0, 0, 0.25);
  }
`;
